import React from "react";
import Modal from "react-modal";
import { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";
import UserComponent from "../components/users/Users";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import { ReactComponent as RoleIcon } from "../icons/role.svg";
import { ReactComponent as UsersIcon } from "../icons/users.svg";
import { jwtDecode } from "jwt-decode";
import DataTable from "react-data-table-component";
import { adminServices } from "../services/AdminServices";
import Button from "../components/Button";
import AlertModal from "../components/AlertModal";
import ConfirmationDialog from '../components/ConfirmationDialog';
import { use } from "react";
const UserPage = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const [roles, setRoles] = useState([]);
  const [pages, setPages] = useState([]);
  const [allPages, setAllPages] = useState([]);
  const [filterPages, setFilterPages] = useState([]);
  const [showRoles, setShowRoles] = useState(false);
  const [selectedRole, setSelectedRole] = useState("");
  const [selectedRoleId, setSelectedRoleId] = useState(0);
  const [selectedPage, setSelectedPage] = useState("0");
  const [addRole, setAddRole] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [showConfirm, setShowConfirm] = useState(false);
  const [confirmMessage, setConfirmMessage] = useState("");
  let _email = "";
  useEffect(() => {
    var token = localStorage.getItem("appToken");
    setIsAdmin(jwtDecode(token)["isAdmin"] === "1");
    _email = jwtDecode(token)["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress"];
  }, []);
  useEffect(() => {
    if (showRoles) {
      getRoles();
      getPages();
    } else {
      setFilterPages([]);
      setAllPages([]);
      setRoles([]);
    }
  }, [showRoles]);
  const getRoles = async () => {
    await adminServices.storeProcedure2("getUserRoles", {}).then(response => {
      if (response.status === 200) {
        setRoles(response.data);
      }
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  const getPages = async () => {
    await adminServices.storeProcedure2("getPages", {}).then(response => {
      if (response.status === 200) {
        setAllPages(response.data);
        setFilterPages(response.data);
      }
    }).catch(error => {
      if (error.status === 401) {
        window.location.href = "/";
      }
    });
  };
  if (!isAdmin) {
    return <UnauthorizedComponent />;
  }
  const handleDeleteRole = async row => {
    if (parseInt(row.numberOfUsers) > 0) {
      setAlertMessage("Cannot delete role with users assigned to it. Kindly remove users from the role before deleting it.");
      setShowAlert(true);
      return;
    }
    setConfirmMessage(`Are you sure you want to delete the role ${row.role_name}?`);
    setShowConfirm(true);
    setSelectedRoleId(row.role_id);
  };
  const handleRoleClick = async r => {
    setSelectedRole(r.role_name);
    setSelectedRoleId(r.role_id);
    await adminServices.storeProcedure2("getRolePages", {
      role_id: r.role_id
    }).then(response => {
      if (response.status === 200) {
        // Set the pages from response.data
        setPages(response.data);
        setSelectedPage("0");
        let filtered = getPagesNotInRolePages(allPages, response.data);
        setFilterPages(filtered);
      }
    });
  };
  const getPagesNotInRolePages = (a, b) => {
    const rolePageIds = b.map(page => page.pageId);
    return a.filter(page => !rolePageIds.includes(page.pageId));
  };
  return <div className="mainContainer">
      <AlertModal show={showAlert} title="Invalid Action" message={alertMessage} onClose={() => {
      setShowAlert(false);
    }} />
      <ConfirmationDialog show={showConfirm} title="Delete Role" message={"Are you sure you want to delete the role?"} onConfirm={async () => {
      await adminServices.storeProcedure2("DeleteRole", {
        pRole: selectedRoleId
      }).then(async response => {
        if (response.status === 200) {
          await getRoles();
          setSelectedRole("");
          setSelectedRoleId(0);
          setSelectedPage("0");
          setPages([]);
          setFilterPages([]);
          setShowConfirm(false);
        }
      }).catch(error => {
        if (error.status === 401) {
          window.location.href = "/";
        }
      });
    }} onCancel={() => {
      setShowConfirm(false);
    }} />
      <div className="d-flex justify-content-end align-items-center mb-3">
        {!showRoles && <div onClick={() => {
        setShowRoles(true);
      }}>
          <RoleIcon style={{
          width: "30px",
          height: "30px"
        }} /> Go To User Roles
        </div>}
      </div>
      {!showRoles && <UserComponent />}

      {showRoles && <div>
        <div onClick={() => {
        setShowRoles(false);
      }} className="mb-3">
          <UsersIcon style={{
          width: "30px",
          height: "30px"
        }} />Go To Users
        </div>
         <h3 style={{
        alignItems: "center",
        display: "flex",
        justifyContent: "start"
      }}><RoleIcon style={{
          width: "30px",
          height: "30px"
        }} />&nbsp;User Roles</h3>
         <div className="d-flex justify-content-end mb-3">
            
        </div>
        <br />
        <div className="d-flex justify-content-between mb-3">
          <div className="col-5 mr-1" style={{
          height: "100%"
        }}>
            <div className="d-flex justify-content-start align-items-center mb-3">
              <span>{"Add Role: "}</span>
              &nbsp;
              <input className="form-control w-50" type="text" placeholder="Enter Role Name" value={addRole} onChange={e => {
              setAddRole(e.target.value);
            }} />
              &nbsp;
              <Button variant="primary" size="xs" onClick={async () => {
              if (addRole.trim() !== "") {
                await adminServices.storeProcedure2("AddRole", {
                  p_roleName: addRole
                }).then(async response => {
                  if (response.status === 200) {
                    await getRoles();
                    setAddRole("");
                  }
                }).catch(error => {
                  //console.log(error);
                  if (error.status === 401) {
                    window.location.href = "/";
                  }
                });
              }
            }}>Add Role</Button>
            </div>
            <DataTable data={roles} columns={[{
            name: "Role",
            selector: row => row.role_name,
            sortable: true
          }, {
            name: "Number of Users",
            selector: row => row.numberOfUsers,
            sortable: true
          }, {
            name: "Action",
            cell: row => {
              return <Button variant="danger" size="xs" onClick={() => {
                handleDeleteRole(row);
              }}>Delete</Button>;
            },
            sortable: true
          }]} striped pointerOnHover onRowClicked={handleRoleClick} />
          </div>

          <div className="col-6" style={{
          height: "100%"
        }}>
            <div className="d-flex justify-content-start align-items-center mb-3">
              <span>{"Selected Role: " + selectedRole}</span>
              &nbsp;
              <select className="form-control w-50" value={selectedPage} onChange={e => {
              setSelectedPage(e.target.value);
            }}>
                <option value="0" selected disabled>Select Page</option>
                {filterPages && filterPages.map(page => {
                return <option key={page.pageId} value={page.pageId}>{page.pageName}</option>;
              })}
              </select>
              &nbsp;
              <Button variant="primary" size="xs" onClick={async () => {
              if (selectedPage === "0") {
                window.alert("Please select a page to add to the role.");
                return;
              }
              await adminServices.storeProcedure2("AddUserRolePage", {
                p_roleId: selectedRoleId,
                p_pageId: selectedPage
              }).then(async response => {
                if (response.status === 200) {
                  handleRoleClick({
                    role_name: selectedRole,
                    role_id: selectedRoleId
                  });
                }
              });
            }}>Add Page</Button>
            </div>
            <DataTable data={pages} columns={[{
            name: "Page",
            selector: row => row.pageName,
            sortable: true
          }, {
            name: "Action",
            cell: row => {
              return <Button variant="danger" size="xs" onClick={async () => {
                var x = window.confirm("Are you sure you want to delete this page from the selected role?");
                if (x) {
                  await adminServices.storeProcedure2("DeleteRolePage", {
                    p_recordId: row.recordId
                  }).then(async response => {
                    if (response.status === 200) {
                      handleRoleClick({
                        role_name: selectedRole,
                        role_id: selectedRoleId
                      });
                    }
                  });
                }
              }}>Delete</Button>;
            },
            sortable: true
          }]} pagination striped pointerOnHover />
          </div>
        </div>  

      </div>}
      {/* Table Footer */}
    </div>;
};
export default UserPage;